import React from 'react';

const RewardsTable = ({ rewardsData, noData }) => {
  return (
    <div className="mt-[74px] overflow-x-scroll lg:overflow-x-auto">
      <table className="min-w-full">
        <thead className="bg-white border-b-2 border-b-[#ECEBEB]">
          <tr>
            <th
              scope="col"
              className="px-4 py-5 font-normal text-left text-black b3"
            >
              Rewards
            </th>
            <th
              scope="col"
              className="px-4 py-5 font-normal text-left text-black b3"
            >
              Received
            </th>
            <th
              scope="col"
              className="px-4 py-5 font-normal text-left text-black b3"
            >
              Amount
            </th>
            <th
              scope="col"
              className="px-4 py-5 font-normal text-left text-black b3"
            >
              Balance
            </th>
            <th
              scope="col"
              className="px-4 py-5 font-normal text-left text-black b3"
            >
              Expires
            </th>
          </tr>
        </thead>
        <tbody>
          {noData ? (
            <tr>
              <td colSpan={5} className="py-6 text-center b3">
                No rewards data available
              </td>
            </tr>
          ) : (
            
            rewardsData.map((reward, index) => (
              <tr key={index} className="border-b-2 border-b-[#ECEBEB]">
                <td className="py-4 px-4 border-b-2 whitespace-nowrap text-[#54565A] b3">
                  {reward.reward}
                </td>
                <td className="py-4 px-4 border-b-2 whitespace-nowrap text-[#54565A] b3">
                  {reward.received}
                </td>
                <td className="py-4 px-4 border-b-2 whitespace-nowrap text-[#54565A] b3">
                  {reward.amount}
                </td>
                <td className="py-4 px-4 border-b-2 whitespace-nowrap text-[#54565A] b3">
                  {reward.balance}
                </td>
                <td className="py-4 px-4 border-b-2 whitespace-nowrap text-[#54565A] b3">
                  {reward.expires}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default RewardsTable;